import React from 'react'
import moment from 'moment'

import { Absolute } from '../helpers/Position'
import CalendarEvent from './CalendarEvent'

const HourlyEvent = React.memo(
  ({ event, hour, ...props }) => {
    const [zIndex, setZIndex] = React.useState(1)
    const date = moment(event.date)

    if (hour !== date.hour()) return false

    return (
      <Absolute
        zIndex={zIndex}
        top={event.distanceTop}
        left={event.distanceLeft + '%'}
        width={event.width + '%'}
        onMouseEnter={() => setZIndex(10)}
        onMouseLeave={() => setZIndex(1)}
      >
        <CalendarEvent
          label={event.name}
          description={event.description}
          time={date.format('HH:mm')}
          bgColor={event.checklist?.configuration?.calendarView?.backgroundColor}
          color={event.color}
          {...props}
        />
      </Absolute>
    )
  },
  ({ event: eventA }, { event: eventB }) =>
    eventA.name === eventB.name &&
    eventA.date === eventB.date &&
    eventA.color === eventB.color &&
    eventA.checklist?.configuration?.calendarView?.backgroundColor ===
      eventB.checklist?.configuration?.calendarView?.backgroundColor
)

export default HourlyEvent
